module.exports = __webpack_public_path__ + "img/02_2.f02d8593.png";